// Mock data for ZHELTA homepage clone

export const NAV_LINKS = [
  { label: 'Home', icon: 'Home', href: '#home' },
  { label: 'ZHELTA Systems', icon: 'Package', href: '#systems' },
  { label: 'ZHELTA Services', icon: 'ShoppingCart', href: '#services' },
  { label: 'ZHELTA Academy', icon: 'GraduationCap', href: '/academy' },
  { label: 'Support', icon: 'UserCircle2', href: '#support' },
  { label: 'About Us', icon: 'Users', href: '#about' },
];

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt-BR', name: 'Português (Brazil)', flag: '🇧🇷' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'th', name: 'ภาษาไทย', flag: '🇹🇭' },
  { code: 'fr-CA', name: 'Français (Canada)', flag: '🇨🇦' },
  { code: 'he', name: 'עברית', flag: '🇮🇱' },
];

export const HERO_SLIDES = [
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Managed IT Services',
    description: 'Flexible pricing models available: Starter, Standard, and Premium packages to fit your needs',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'IT Systems Management',
    description: 'End-to-end oversight that keeps critical systems optimized, secure, and running smoothly.',
    image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'IT Help Desk & Remote Support',
    description: 'Responsive, expert help—on-demand support for everyday tech needs.',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Cloud Solutions',
    description: 'Scalable, resilient cloud infrastructure tailored to your business.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Network Infrastructure',
    description: 'Robust, reliable networks built for performance and uptime.',
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'IT Infrastructure Deployment',
    description: 'From planning to rollout—deployment done right, the first time.',
    image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Cybersecurity Support',
    description: 'Protect your systems from threats with layered security, monitoring, and response-ready safeguards.',
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Backup & Data Protection',
    description: 'Automated backups and data recovery strategies that keep your business running.',
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Surveillance Camera Deployment',
    description: 'Modern surveillance systems for secure, connected spaces.',
    image: 'https://images.unsplash.com/photo-1557597774-9d273605dfa9?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Website Development',
    description: 'Beautiful, high-performing websites that represent your brand.',
    image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'Application Development',
    description: 'Custom applications designed to solve real business challenges.',
    image: 'https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
  {
    label: 'ZHELTA SYSTEMS',
    title: 'IT Consulting & Technology Advisory',
    description: 'Strategic guidance to navigate technology decisions with confidence.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2000&q=80',
    cta: 'Learn More',
  },
];

export const FEATURED_SERVICES = [
  {
    title: 'Managed IT Services',
    description: 'Complete IT infrastructure management with proactive support and operational stability for your business.',
  },
  {
    title: 'IT Systems Management',
    description: 'End-to-end oversight and day-to-day administration that keeps your critical systems optimized, secure, and running smoothly.',
  },
  {
    title: 'IT Help Desk & Remote Support',
    description: 'Responsive, expert help desk and remote support—on-demand assistance for everyday tech needs and fast issue resolution.',
  },
  {
    title: 'Cloud Solutions',
    description: 'Scalable, resilient cloud infrastructure tailored to your business, designed for performance, security, and cost efficiency.',
  },
  {
    title: 'Network Infrastructure',
    description: 'Robust, reliable networks engineered for performance, uptime, and secure connectivity across your entire organization.',
  },
  {
    title: 'IT Infrastructure Deployment',
    description: 'From planning to rollout—deployment done right the first time, with clear timelines and minimal disruption to your business.',
  },
  {
    title: 'Cybersecurity Support',
    description: 'Protect your systems from threats with layered security, continuous monitoring, and response-ready safeguards.',
  },
  {
    title: 'Backup & Data Protection',
    description: 'Automated backups, encryption, and recovery strategies that keep your business running even when the unexpected happens.',
  },
  {
    title: 'Surveillance Camera Deployment',
    description: 'Professional surveillance system deployment for secure monitoring and improved facility protection.',
  },
  {
    title: 'Website Development',
    description: 'Beautiful, high-performing websites that represent your brand and convert visitors into customers.',
  },
  {
    title: 'Application Development',
    description: 'Custom applications designed to solve real business challenges with clean, maintainable, production-ready code.',
  },
  {
    title: 'IT Consulting & Technology Advisory',
    description: 'Strategic guidance to navigate technology decisions with confidence, from roadmaps to vendor selection and architecture reviews.',
  },
];

// Cart-central is now hosted INSIDE this monorepo at /store/* (frontend)
// and /api/store/* (backend). Keeping the export name unchanged so every
// existing call-site (Footer link, Services page, ServicesProductDetail
// "Buy" CTA, etc.) just routes to the local store transparently.
export const ZHELTA_SHOP_URL = '/store';
export const ZHELTA_SHOP_API = '/api/store';
export const ZHELTA_SYSTEMS_URL = '/systems';

export const CORE_SERVICES = [
  {
    title: 'ZHELTA SYSTEMS',
    // Customer-uploaded hero — replacement chosen by the user (previous was
    // 7yd02pka). Shows the Systems "Managed IT Services" overview shot.
    image: 'https://customer-assets.emergentagent.com/job_zhelta-rebuild/artifacts/pxy6bkin_image.png',
    href: ZHELTA_SYSTEMS_URL,
    external: false,
  },
  {
    title: 'ZHELTA Services',
    // Customer-uploaded hero — Apple/Dell/Lenovo/Microsoft product lineup
    // montage (reverted from imluhjw3 back to this previous version per
    // user preference).
    image: 'https://customer-assets.emergentagent.com/job_zhelta-rebuild/artifacts/nhh07cpo_image.png',
    href: '/services',
    external: false,
  },
  {
    title: 'ZHELTA Academy',
    // Customer-uploaded hero — student with headphones studying on a
    // laptop + tablet with course-progress UI visible (Web Dev, Python,
    // Data Science, UI/UX). Anchors "self-paced IT training" clearly.
    image: 'https://customer-assets.emergentagent.com/job_zhelta-rebuild/artifacts/hj0qgvcx_image.png',
    href: '/academy',
    external: false,
  },
];

export const WHY_CHOOSE = [
  {
    title: 'One unified platform',
    description: 'Technology, education, and digital services—designed to work together seamlessly.',
    icon: 'Layers',
  },
  {
    title: 'Built with intention',
    description: 'Clear systems, thoughtful design, and solutions that scale as needs evolve.',
    icon: 'Target',
  },
  {
    title: "Focused on what's next",
    description: "We don't just solve today's problems—we prepare you for what comes next.",
    icon: 'Compass',
  },
];

export const TRUST_BADGES = [
  'Built on more than a decade of practice',
  '12+ Years in Practice',
  'Three Integrated Divisions',
  'Multi-Language Platform',
  'No Long-Term Contracts',
];

export const FOOTER_LINKS = {
  Company: ['About Us', 'Mission', 'Vision', 'Careers'],
  Platform: ['ZHELTA Systems', 'ZHELTA Services', 'ZHELTA Academy'],
  Support: ['Help Center', 'LiveChat', 'Contact'],
  Legal: ['Privacy Policy', 'Terms of Service', 'Cookies'],
};
